import axios, { AxiosRequestConfig, AxiosResponse } from "axios"
import Settings from "./Settings"

const options: AxiosRequestConfig = {
  headers: { "Content-Type": "application/json", accept: "text/plain" },
  // withCredentials: true, // Commented out - requires server to send Access-Control-Allow-Credentials: true
}

export const APIService = {
  postAction: async (
    endpoint: string,
    params?: unknown,
    newOpts?: AxiosRequestConfig
  ): Promise<AxiosResponse> => {
    return axios.post(
      Settings.BasePathForAPI + endpoint,
      params !== null ? params : null,
      newOpts !== null ? newOpts : options
    )
  },

  getAction: async (
    endpoint: string,
    params?: string,
    newOpts?: AxiosRequestConfig
  ): Promise<AxiosResponse> => {
    return axios.get(
      Settings.BasePathForAPI +
        endpoint +
        (params !== undefined && params !== null ? "?" + params : ""),
      newOpts !== undefined && newOpts !== null ? newOpts : options
    )
  },

  postActionExternal: async (
    endpoint: string,
    params?: unknown,
    newOpts?: AxiosRequestConfig
  ): Promise<AxiosResponse> => {
    return axios.post(
      endpoint,
      params !== null ? params : null,
      newOpts !== null ? newOpts : options
    )
  },

  getActionExternal: async (
    endpoint: string,
    newOpts?: AxiosRequestConfig
  ): Promise<AxiosResponse> => {
    return axios.get(endpoint, newOpts)
  },
}

export default APIService
